<template>
  <div class="empty-state">
    <i :class="['fa', icon, 'empty-icon']" aria-hidden="true"></i>
    <div class="empty-title">{{ computedTitle }}</div>
    <div class="empty-desc">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: {
      type: String,
      default: 'fa-clipboard-list',
    },
    title: {
      type: String,
      default: 'No data found',
    },
    description: {
      type: String,
      default: 'Data will appear here when available.',
    },
    hasActiveFilter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedTitle() {
      return this.hasActiveFilter ? 'No results found' : this.title;
    },
  },
};
</script>

<style scoped>
.empty-state {
  text-align: center;
  padding: 48px 0;
}
.empty-icon {
  font-size: 28px;
  color: #26a246;
  margin-bottom: 16px;
}
.empty-title {
  font-size: 18px;
  color: #888;
}
.empty-desc {
  color: #aaa;
  margin-top: 8px;
}
</style> 